<template>
  <div class="inline-flex items-center gap-1 font-medium" :class="displayClasses">
    <font-awesome-icon :icon="icon" />
    <span>{{ label }}</span>
  </div>
</template>

<script>
import { defineComponent } from "@vue/runtime-core";

export default defineComponent({
  name: "NotificationTypeValue",
  computed: {
    normalizedType() {
      const type = String(this.params.value || "").toLowerCase();
      if (type === "warn" || type === "warning") return "warn";
      if (type === "error") return "error";
      return "info";
    },
    displayClasses() {
      if (this.normalizedType === "warn") return "text-orange-700";
      if (this.normalizedType === "error") return "text-red-700";
      return "text-blue-700";
    },
    icon() {
      if (this.normalizedType === "warn") return "exclamation-circle";
      if (this.normalizedType === "error") return "times-circle";
      return "info-circle";
    },
    label() {
      if (this.normalizedType === "warn") return "Warn";
      if (this.normalizedType === "error") return "Error";
      return "Info";
    },
  },
});
</script>
